export default {
    dashboard: {
        totalWordsGenerated: 'Yhteensä luodut sanat',
        wordsPerDay: 'Sanoja/päivä',
        content: 'Sisältö',
        date: 'Päiväys',
        variationCount: 'Muunnelmien määrä',
        transactionId: 'Tapahtuman tunnus',
        totalWordsCount: 'Sanamäärä yhteensä',
        action: 'Toiminta',
        goTo: 'Mene',
        viewMore: 'Näytä lisää',
        showLess: 'Näytä vähemmän',
        tabImage: 'Kuva',
        tabText: 'Teksti',
        dashboardSubtitle: 'Hallitse tekoälyn luomaa sisältöäsi',
        type: 'Tyyppi',
    },
};
